import React from "react";
import { LayoutHeader } from "../components";
import { Experience } from "../containers";

const ExperiencePage = () => (
  <LayoutHeader>
    <Experience />
  </LayoutHeader>
);

export default ExperiencePage;
